import { initData } from '@/api/user'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      url: '',
      listData: [],
      words: '',
      page: 1, // params的page需要-1,接口文档是从0开始.
      size: 10,
      total: 0,
      params: {},
      time: 170,
      query: {},
      sort: '',
       // 展示多少个页面,
      // query 各自在页面定义
    }
  },
  watch:{
    page(){
      this.init();
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
    pageSize(){
      return Math.ceil(this.total / this.size);
    },
    max(){
      if(!this.realMobile){
        return 9;
      }else {
        return 5;
      }
    }
  },
  methods: {
    async init() {
      if (!await this.beforeInit()) {
        return
      }
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        initData(this.url, this.params).then(res => {
          this.$vs.loading.close();
          if(res.code == 400) return;//400不弹错误消息
          if(res.code == 200) {
            let content = res.page || res.list || res.data;
            this.listData = content.list || content.items;
            if(+content.totalCount){
              this.total = +content.totalCount;
            }
            if(content.list && !content.list.length){
              this.total = 0;
            }
            if(this.statistics){
              this.statistics = content.statistics;
            }
            if(this.selected){
              this.selected.length = 0;
              document.querySelector(".vs-table-outer .vs-con-table").__vue__.$emit('input', []);
            }
            resolve(res)
          }else {
            this.$message.error(res.msg);
          }

        }).catch(err => {
          this.$vs.loading.close();
          reject(err)
        })
      })
    },
    beforeInit() {
      return true
    },

    // todo需要另外调整
    pageChange(e) {
      this.page = e ;
      this.init();
    },
    sizeChange(e) {
      this.page = 1;
      this.size = e;
      this.init();
    },
    toQuery(){
      this.page = 1;
      this.init();
    },
    // 排序
    sortChange(column){
      this.sort = `${column.prop},${column.order == 'ascending' ? 'asc' : 'desc' }`;
      this.init();
    }
  }
}
